'use strict';

function CompanyService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId', {companyId: '@id'}, {
    'update': { method:'PUT' },
    'queryTags': {
      url: config.apiBase + '/companies/:companyId/tags',
      method: 'GET',
      isArray: true
    },
    'queryTagSuggestions': {
      url: config.apiBase + '/companies/:companyId/tag-suggestions',
      method: 'GET',
      isArray: true
    },
    'updateTagSuggestions': {
      url: config.apiBase + '/companies/:companyId/tag-suggestions',
      method: 'PUT',
      isArray: true
    },
    'queryPriorities': {
      url: config.apiBase + '/companies/:companyId/priorities',
      method: 'GET',
      isArray: true
    },
    'updatePriorities': {
      url: config.apiBase + '/companies/:companyId/priorities',
      method: 'PUT',
      isArray: true
    },
    'queryTaskStatuses': {
      url: config.apiBase + '/companies/:companyId/reminder-status',
      method: 'GET',
      isArray: true
    },
    'updateTaskStatuses': {
      url: config.apiBase + '/companies/:companyId/reminder-status',
      method: 'PUT',
      isArray: true
    },
    'queryTaskTypes': {
      url: config.apiBase + '/companies/:companyId/reminder-type',
      method: 'GET',
      isArray: true
    },
    'updateTaskTypes': {
      url: config.apiBase + '/companies/:companyId/reminder-type',
      method: 'PUT',
      isArray: true
    },
    'queryCustomerStatus': {
      url: config.apiBase + '/companies/:companyId/customerStatuses',
      method: 'GET',
      isArray: true
    },
    'queryCustomerCategory': {
      url: config.apiBase + '/companies/:companyId/customers/categories',
      method: 'GET',
      isArray: true
    },
    'updateCustomerStatuses': {
      url: config.apiBase + '/companies/:companyId/customerStatuses',
      method: 'PUT',
      isArray: true
    },
    'queryOrderStatuses': {
      url: config.apiBase + '/companies/:companyId/order-status',
      method: 'GET',
      isArray: true
    },
    'updateOrderStatus': {
      url: config.apiBase + '/companies/:companyId/order-status',
      method: 'PUT',
      isArray: true
    },
    'queryNotices':  {
      url: config.apiBase + '/notices',
      method: 'GET',
      isArray: true
    },
    'queryUnits': {
      url: config.apiBase + '/companies/:companyId/units',
      method: 'GET',
      isArray: true
    },
    'updateUnits': {
      url: config.apiBase + '/companies/:companyId/units',
      method: 'POST'
    },
    'queryPdfTemplates': {
      url: config.apiBase + '/companies/:companyId/pdf-templates',
      method: 'GET',
      isArray: true
    },
    'queryFeed': {
      url: config.apiBase + '/companies/:companyId/feed',
      method: 'GET',
      isArray: true
    },
    'getLoginAnalytics': {
      url: config.apiBase + '/companies/:companyId/third-logins',
      method: 'GET',
      isArray: true
    },
    'updateThirdPartyLogin': {
      url: config.apiBase + '/companies/:companyId/third-logins/:id',
      method: 'PUT',
      isArray: false
    },
    'createThirdPartyLogin': {
      url: config.apiBase + '/companies/:companyId/third-logins',
      method: 'POST',
      isArray: false
    },
    'createReportAnalyticsPdf2': {
      url: config.apiBase + '/companies/:companyId/report-analytics/pdf2',
      method: 'POST'
    },
    'loginAnalytic': {
      url: config.apiBase + '/companies/:companyId/report-analytics/login',
      method: 'POST'
    },
    'updateAnalytic': {
      url: config.apiBase + '/companies/:companyId/third-logins/:loginId',
      method: 'PUT'
    },
    'deleteLoginAnalytic': {
      url: config.apiBase + '/companies/:companyId/third-logins/:loginId',
      method: 'DELETE'
    }
  });
}

function CompanyCustomerService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/services/:serviceId', {}, {
    'update': {
      url: config.apiBase + '/companies/:companyId/services/:serviceId',
      method: 'PUT'
    },
    'queryComments': {
      url: config.apiBase + '/companies/:companyId/services/:serviceId/comments',
      method: 'GET',
      isArray: true
    },
    'createComment': {
      url: config.apiBase + '/companies/:companyId/services/:serviceId/comments',
      method: 'POST'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyService', ['$resource', 'config', CompanyService])
  .factory('CompanyCustomerService', ['$resource', 'config', CompanyCustomerService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyService.js
// module id = 4
// module chunks = 0